var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9417 6.78243C17.8074 6.38269 17.4614 6.09124 17.0448 6.02753L12.1964 5.28662L10.0186 0.647184C9.83288 0.25173 9.43601 0 8.99999 0C8.56369 0 8.16711 0.25173 7.98139 0.647184L5.80332 5.28691L0.954877 6.02781C0.538292 6.09153 0.192281 6.38269 0.058277 6.78272C-0.0757274 7.18274 0.0254188 7.62334 0.32 7.92565L3.86069 11.5564L3.02209 16.6931C2.95294 17.1182 3.13323 17.5457 3.48496 17.7943C3.8364 18.0429 4.30041 18.068 4.67843 17.8594L9.00028 15.4693L13.3221 17.8594C13.4927 17.9537 13.6804 18 13.8673 18C14.0947 18 14.3222 17.9309 14.5156 17.7943C14.8673 17.546 15.0473 17.1185 14.9782 16.6931L14.1396 11.5564L17.6806 7.92565C17.9746 7.62334 18.0757 7.18274 17.9417 6.78243Z",
    fill: "#F7C000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveStar);
export default __webpack_public_path__ + "static/media/ActiveStar.8d651603ad7864dc820110507f5555ba.svg";
export { ForwardRef as ReactComponent };